// src/components/toast.ts
let containerEl: HTMLDivElement | null = null;

function ensureContainer(): HTMLDivElement {
  if (containerEl && document.body.contains(containerEl)) return containerEl;
  containerEl = document.createElement('div');
  containerEl.className = 'toast-container';
  document.body.appendChild(containerEl);
  return containerEl;
}

export interface ToastOptions {
  duration?: number;
  type?: 'info' | 'warn' | 'error' | 'success';
}

/**
 * 显示一个轻量提示,自动消失。
 */
export function showToast(message: string, options: ToastOptions = {}): void {
  const { duration = 3000, type = 'info' } = options;
  const container = ensureContainer();
  const el = document.createElement('div');
  el.className = `toast toast-${type}`;
  el.textContent = message;
  container.appendChild(el);
  // 触发入场动画
  requestAnimationFrame(() => el.classList.add('toast-show'));
  setTimeout(() => {
    el.classList.remove('toast-show');
    el.classList.add('toast-hide');
    setTimeout(() => el.remove(), 300);
  }, duration);
}
